import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Fuente } from '../model/Fuente';
import { PlacaVideo } from '../model/PlacaVideo';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_VideoFuente extends FuncionCompatilibidadBase<PlacaVideo, Fuente> {
  funciones = {
    pines: (video: PlacaVideo, fuente: Fuente): Incompatibilities | null => {
      // se genera objeto local de fuente

      let $fuente = {
        _16pines: fuente.$caracteristicas.pcie_16pines,
        pcie: fuente.$caracteristicas.pines_pcie,
        pcieplus: fuente.$caracteristicas.pines_pcieplus,
      };

      // se genera objeto local de placa de video
      const $placa = {
        _16pines: video.$caracteristicas._16pines || 0,
        _16pines_adaptadores: video.$caracteristicas.adaptador_16pines || 0,
        _16pinesCantidadConexion: video.$caracteristicas._16pines_conexion || 0,
        _16pinesCablesPorAdaptador:
          video.$caracteristicas.adaptador_16pines ||
          0 * video.$caracteristicas._16pines_conexion ||
          0,
        _2plusNecesarios: video.$caracteristicas._2plus || 0,
        _6pinesNecesarios: video.$caracteristicas._6pines || 0,
      };

      // en caso de que SI se tengan los 16 pines en video
      if ($placa._16pines) {
        // se restan los pines de la fuente a los de la placa para saber cuantos adaptadores necesito
        let adaptadoresNecesarios = $placa._16pines - $fuente._16pines;

        // estas son las cantidades de conexiones de la fuente
        let cantidadConexionesFuente = Math.min($fuente.pcie, $fuente.pcieplus);

        // si los adaptadores de la placa no son los necesarios para cubrir a la fuente

        if ($placa._16pines_adaptadores < adaptadoresNecesarios) {
          return {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'Pines de fuente insuficientes',
          };
        }
        // si los adaptadores de la placa SI son los necesarios para cubrir a la fuente
        else {
          // se chequean las cantidades de conexiones de la fuente, y si son menores que los de la placa tira incompatibilidad

          if (cantidadConexionesFuente < $placa._16pinesCantidadConexion) {
            return {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: 'Pines de fuente insuficientes',
            };
          }
        }
      }
      // en el caso de que no se tengan los 16 pines en video
      else {
        if (
          $fuente.pcieplus >= $placa._2plusNecesarios &&
          $fuente.pcie >= $placa._6pinesNecesarios
        ) {
          return null;
        } else {
          return {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'Pines de fuente insuficientes',
          };
        }
      }
      return null;
    },
    capacidad: (video: PlacaVideo, fuente: Fuente): Incompatibilities | null => {
      return fuente.$caracteristicas.w_real >= video.$caracteristicas.w_total * 0.95 ?
          null
        : {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility:
              'La fuente no posee los watts recomendados para la placa de video seleccionada',
          };
    },
  };
}
